import { render, staticRenderFns } from "./PostInfo.vue?vue&type=template&id=66ed6747&scoped=true&"
import script from "./PostInfo.vue?vue&type=script&lang=js&"
export * from "./PostInfo.vue?vue&type=script&lang=js&"
import style0 from "./PostInfo.vue?vue&type=style&index=0&id=66ed6747&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed6747",
  null
  
)

export default component.exports